import { useCallback } from 'react';
import { useLocation, useNavigate, type NavigateOptions } from 'react-router-dom';
import { withImpersonation } from '../../utils/impersonation';

/**
 * Drop-in replacement for `useNavigate` (path form only) that carries the `?email=`
 * impersonation parameter over to the destination, so impersonation stays active
 * until the parameter is removed from the URL.
 */
export const useImpersonationNavigate = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  return useCallback(
    (path: string, options?: NavigateOptions) => navigate(withImpersonation(path, search), options),
    [navigate, search],
  );
};
